import React from 'react'
import './home.scss'

export default function Home() {
    return (
        <div>Home</div>
    )
}
